import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import InlineHelpText from '../../shared/InlineHelpText';
import HelpIcon from '../../shared/HelpIcon';
import SvgXIcon from '../../svg/XIcon';
import {
  deviceDescriptionText,
  deviceIdText,
  editText,
  notesText,
} from '../../shared/SharedInternationalizations';
import SvgCheckMarkIcon from '../../svg/CheckMarkIcon';
import permissions from '../../../permissionsList';
import AccessControl from '../../../AccessControl';

export function UnconnectedAlertEmailDisplay(props) {
  const {
    notify_on_clear,
    notes,
    alert_device_id,
    alert_description,
    alert_device_type,
    alert_device_category,
    short_msg,
    email_address,
  } = props.deviceDetails;
  const {
    assignedInfo,
    deviceType,
    assignedGroupNames,
    alertCategoryName,
    previous,
    'data-test': dataTest,
  } = props;

  const [showDescriptionHelpText, setShowDescriptionHelpText] = useState(false);
  function toggleShowDescriptionHelpText(value) {
    setShowDescriptionHelpText(value);
  }
  const descriptionHelpTextRef = useRef();
  const descriptionHelpText = (
    <FormattedMessage
      id="alertEmailDisplay.descriptionHelpText"
      defaultMessage="The description for this device."
    />
  );
  const [showDeviceIdHelpText, setShowDeviceIdHelpText] = useState(false);
  function toggleShowDeviceIdHelpText(value) {
    setShowDeviceIdHelpText(value);
  }
  const deviceIdHelpTextRef = useRef();
  const deviceIdHelpText = (
    <FormattedMessage
      id="alertEmailDisplay.deviceIdHelpText"
      defaultMessage="This is the device's Id."
    />
  );
  const [showDeviceTypeHelpText, setShowDeviceTypeHelpText] = useState(false);
  function toggleShowDeviceTypeHelpText(value) {
    setShowDeviceTypeHelpText(value);
  }
  const deviceTypeHelpTextRef = useRef();
  const deviceTypeHelpText = (
    <FormattedMessage
      id="alertEmailDisplay.deviceTypeHelpText"
      defaultMessage="This is the assigned type for this device."
    />
  );

  const [showShortMsgHelpText, setShowShortMsgHelpText] = useState(false);
  function toggleShowShortMsgHelpText(value) {
    setShowShortMsgHelpText(value);
  }
  const shortMsgHelpTextRef = useRef();
  const shortMsgHelpText = (
    <FormattedMessage
      id="userPrimaryAlertEmailDisplay.shortMsgHelpText"
      defaultMessage="SARA is able to use a short message format for email addresses. This is usually used for email to text purposes."
    />
  );

  const [
    showNotifyWhenClearedHelpText,
    setShowNotifyWhenClearedHelpText,
  ] = useState(false);
  function toggleShowNotifyWhenClearedHelpText(value) {
    setShowNotifyWhenClearedHelpText(value);
  }
  const notifyWhenClearedHelpTextRef = useRef();
  const notifyWhenClearedHelpText = (
    <FormattedMessage
      id="userPrimaryAlertEmailDisplay.notifyWhenClearedHelpText"
      defaultMessage="When an alert is cleared, devices can be sent an alert to indicate the alarm is cleared."
    />
  );
  const [showNotesHelpText, setShowNotesHelpText] = useState(false);
  function toggleShowNotesHelpText(value) {
    setShowNotesHelpText(value);
  }
  const notesHelpTextRef = useRef();
  const notesHelpText = (
    <FormattedMessage
      id="userPrimaryAlertEmailDisplay.notesHelpText"
      defaultMessage="These are notes that are available for this device for future reference."
    />
  );
  const [
    showDeviceAssignmentHelpText,
    setShowDeviceAssignmentHelpText,
  ] = useState(false);
  function toggleShowDeviceAssignmentHelpText(value) {
    setShowDeviceAssignmentHelpText(value);
  }
  const deviceAssignmentHelpTextRef = useRef();
  const deviceAssignmentHelpText = (
    <FormattedMessage
      id="alertEmailDisplay.deviceAssignmentHelpText"
      defaultMessage="This is the assignment for this device. The device can be assigned to a user or a unit."
    />
  );
  const [showAlertCategoryHelpText, setShowAlertCategoryHelpText] = useState(
    false
  );
  function toggleShowAlertCategoryHelpText(value) {
    setShowAlertCategoryHelpText(value);
  }
  const alertCategoryHelpTextRef = useRef();
  const alertCategoryHelpText = (
    <FormattedMessage
      id="alertEmailDisplay.alertCategoryHelpText"
      defaultMessage="Devices can be assigned to alert categories as a way of better organizing them."
    />
  );
  const [showAlertGroupsHelpText, setShowAlertGroupsHelpText] = useState(false);
  function toggleShowAlertGroupsHelpText(value) {
    setShowAlertGroupsHelpText(value);
  }
  const alertGroupsHelpTextRef = useRef();
  const alertGroupsHelpText = (
    <FormattedMessage
      id="alertEmailDisplay.alertGroupsHelpText"
      defaultMessage="These are alert groups that this device is assigned to."
    />
  );

  return (
    <div data-test={dataTest}>
      <div className="content-display__container content-display__container--column align-center">
        <FormattedMessage
          id="AlertEmailDisplay.addAlertEmailTitle"
          defaultMessage="View Alert Details for Email: {device}"
          description="The title for the page to edit a unit"
          values={{
            device: email_address,
          }}>
          {(txt) => (
            <h1
              className="no-margin text-deep-blue  text-center"
              data-test="header-text-device">
              {txt}
            </h1>
          )}
        </FormattedMessage>

        <hr />
      </div>

      <div className="content-display__container" data-test="content-container">
        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="AlertEmailDisplay.deviceAssignment"
                  defaultMessage="Device Assigned To"
                  description="This alert phone number is assigned to:"
                  data-test="assigned-to-text"
                />
              </div>
              <div className="item-container__secondary-text text-medium text-bold">
                {assignedInfo.length > 0 ? assignedInfo : ''}
              </div>
            </div>

            <div className="item-container__info-container">
              <HelpIcon
                onClick={() =>
                  deviceAssignmentHelpTextRef.current.toggleHelpText()
                }
                toggled={showDeviceAssignmentHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={deviceAssignmentHelpTextRef}
            toggleFunction={toggleShowDeviceAssignmentHelpText}
            message={deviceAssignmentHelpText}
          />
        </div>

        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                <FormattedMessage
                  id="alertEmailDisplay.deviceType"
                  defaultMessage="Device Type"
                  description="This alert phone number is assigned to:"
                  data-test="device-type-text"
                />
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="device-type-container">
                {deviceType}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => deviceTypeHelpTextRef.current.toggleHelpText()}
                toggled={showDeviceTypeHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={deviceTypeHelpTextRef}
            toggleFunction={toggleShowDeviceTypeHelpText}
            message={deviceTypeHelpText}
          />
        </div>

        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {deviceDescriptionText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="alert-description-container">
                {alert_description}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => descriptionHelpTextRef.current.toggleHelpText()}
                toggled={showDescriptionHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={descriptionHelpTextRef}
            toggleFunction={toggleShowDescriptionHelpText}
            message={descriptionHelpText}
          />
        </div>

        <div className="content-display__column content-display__column--1-2">
          <div className="content-display__item-pill-container">
            <div className="item-container__main-container">
              <div className="item-container__main-text text-large text-light">
                {deviceIdText}
              </div>
              <div
                className="item-container__secondary-text text-medium text-bold"
                data-test="alert-device-id-container">
                {alert_device_id}
              </div>
            </div>
            <div className="item-container__info-container">
              <HelpIcon
                onClick={() => deviceIdHelpTextRef.current.toggleHelpText()}
                toggled={showDeviceIdHelpText}
              />
            </div>
          </div>
          <InlineHelpText
            ref={deviceIdHelpTextRef}
            toggleFunction={toggleShowDeviceIdHelpText}
            message={deviceIdHelpText}
          />
        </div>

        {notes ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="notes-container">
            <div className="content-display__item-pill-container">
              <div className="item-container__main-container">
                <div className="item-container__main-text text-large text-light">
                  {notesText}
                </div>
                <div
                  className="item-container__secondary-text text-medium text-bold"
                  data-test="notes-text-container">
                  {notes}
                </div>
              </div>
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() => notesHelpTextRef.current.toggleHelpText()}
                  toggled={showNotesHelpText}
                />
              </div>
            </div>
            <InlineHelpText
              ref={notesHelpTextRef}
              toggleFunction={toggleShowNotesHelpText}
              message={notesHelpText}
            />
          </div>
        ) : (
          ''
        )}
        {alert_device_type === 4 ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="short-msg-container">
            <div className="content-display__item-pill-container">
              {short_msg ? (
                <React.Fragment>
                  <div className="item-container__info-container">
                    <SvgCheckMarkIcon className="text-success" />
                  </div>
                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="userPrimaryAlertEmailDisplay.shortMessageTrueText"
                        defaultMessage="SARA <b>will</b> use a short message format for this email"
                        description="This user will receive check-in report emails"
                        data-test="short-message-true"
                        values={{
                          b: (msg) => (
                            <span className="item-container__text-highlighted">
                              {msg}
                            </span>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="item-container__info-container">
                    <SvgXIcon className="text-alert" />
                  </div>
                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="userPrimaryAlertEmailDisplay.shortMessageFalseText"
                        defaultMessage="SARA <b>will not</b> use a short message format for this email"
                        description="This user will receive check-in report emails"
                        data-test="short-message-false"
                        values={{
                          b: (msg) => (
                            <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                              {msg}
                            </span>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              <div className="item-container__info-container">
                <HelpIcon
                  styles="margin-left-5"
                  onClick={() => shortMsgHelpTextRef.current.toggleHelpText()}
                  toggled={showShortMsgHelpText}
                />
              </div>
            </div>

            <InlineHelpText
              ref={shortMsgHelpTextRef}
              toggleFunction={toggleShowShortMsgHelpText}
              message={shortMsgHelpText}
            />
          </div>
        ) : (
          ''
        )}
        {alert_device_type === 4 ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="alert-when-cleared-container">
            <div className="content-display__item-pill-container">
              {notify_on_clear ? (
                <React.Fragment>
                  <div className="item-container__info-container">
                    <SvgCheckMarkIcon className="text-success" />
                  </div>

                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="alertEmailDisplay.notifyOnClearTrueText"
                        defaultMessage="SARA <b>will</b> send this device a message when an alarm is cleared."
                        description="This user <b>will</b> receive check-in report emails"
                        data-test="alert-when-cleared-true"
                        values={{
                          b: (msg) => (
                            <span className="item-container__text-highlighted">
                              {msg}
                            </span>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="item-container__info-container">
                    <SvgXIcon className="text-alert" />
                  </div>
                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="alertEmailDisplay.notifyOnClearFalseText"
                        defaultMessage="SARA <b>will not</b> send this device a message when an alarm is cleared."
                        description="This user will receive check-in report emails"
                        data-test="alert-when-cleared-false"
                        values={{
                          b: (msg) => (
                            <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                              {msg}
                            </span>
                          ),
                        }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              <div className="item-container__info-container">
                <HelpIcon
                  onClick={() =>
                    notifyWhenClearedHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showNotifyWhenClearedHelpText}
                />
              </div>
            </div>
            <InlineHelpText
              ref={notifyWhenClearedHelpTextRef}
              toggleFunction={toggleShowNotifyWhenClearedHelpText}
              message={notifyWhenClearedHelpText}
            />
          </div>
        ) : (
          ''
        )}

        <div
          className="content-display__column content-display__column--1-2"
          data-test="assigned-groups-container">
          <div className="content-display__item-pill-container">
            {assignedGroupNames.length > 0 ? (
              <React.Fragment>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertEmailDisplay.alertGroupsText"
                      defaultMessage="Alert Groups"
                      description="This user will receive check-in report emails"
                      data-test="assigned-alert-groups"
                    />
                  </div>
                  <div className="item-container__secondary-text text-medium text-bold">
                    {assignedGroupNames.map((group, index) => (
                      <div className="" key={index}>
                        {group}
                      </div>
                    ))}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="item-container__info-container">
                  <SvgXIcon className="text-alert" />
                </div>
                <div className="item-container__main-container vertical-center">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="AlertEmailDisplay.callAfterMessageTrueText"
                      defaultMessage="This device is <b>not</b> assigned to any alert groups"
                      description="This user  will receive check-in report emails"
                      data-test="not-assigned-alert-groups"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                  <div className="item-container__secondary-text text-medium"></div>
                </div>
              </React.Fragment>
            )}
            <AccessControl
              data-test="access-control"
              feature={permissions.static.devices.alert.editAlertDevice}>
              <div className="item-container__info-container">
                <Link
                  data-test="associate-alert-group-link"
                  to={`/devices/alert/${alert_device_id}/edit/?mode=associateAlertGroup`}
                  state={{
                    modal: true,
                    previous: previous,
                  }}
                  className="link-button button-secondary button-xsm text-small margin-right-10">
                  <FormattedMessage
                    id="alertEmailDisplay.quickEditUnitsText"
                    defaultMessage="Edit Alert Groups"
                    description="A link to open the interface to edit the units assigned to this user"
                  />
                </Link>
                <HelpIcon
                  onClick={() =>
                    alertGroupsHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showAlertGroupsHelpText}
                />
              </div>
            </AccessControl>
          </div>

          <InlineHelpText
            ref={alertGroupsHelpTextRef}
            toggleFunction={toggleShowAlertGroupsHelpText}
            message={alertGroupsHelpText}
          />
        </div>

        {alert_device_type === 4 ? (
          <div
            className="content-display__column content-display__column--1-2"
            data-test="alert-category-container">
            {alert_device_category ? (
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="alertEmailDisplay.alertCategoryText"
                      defaultMessage="Alert Device Category"
                      description="This user will receive check-in report emails"
                      data-test="alert-category-text"
                    />
                  </div>
                  <div className="item-container__secondary-text text-medium text-bold">
                    {alertCategoryName}
                  </div>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      alertCategoryHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showAlertCategoryHelpText}
                  />
                </div>
              </div>
            ) : (
              <div className="content-display__item-pill-container">
                <div className="item-container__info-container">
                  <SvgXIcon className="text-alert" />
                </div>
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="alertEmailDisplay.deviceNotAssigned"
                      defaultMessage="This device is <b>not</b> assigned to an alert category"
                      description="This user  will receive check-in report emails"
                      data-test="alert-category-false"
                      values={{
                        b: (msg) => (
                          <span className="item-container__text-highlighted item-container__text-highlighted--alert">
                            {msg}
                          </span>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <HelpIcon
                    onClick={() =>
                      alertCategoryHelpTextRef.current.toggleHelpText()
                    }
                    toggled={showAlertCategoryHelpText}
                  />
                </div>
              </div>
            )}

            <InlineHelpText
              ref={alertCategoryHelpTextRef}
              toggleFunction={toggleShowAlertCategoryHelpText}
              message={alertCategoryHelpText}
            />
          </div>
        ) : (
          ''
        )}
      </div>
      <AccessControl
        data-test="access-control"
        feature={permissions.static.devices.alert.editAlertDevice}>
        <div className="width-100 align-center flex-end">
          <Link
            data-test="edit-alert-email-link"
            className="link-button button-secondary button-sm text-small margin-left-10"
            to={`/devices/alert/${alert_device_id}/edit/`}
            state={{
              modal: true,
              previous: props.previous,
            }}>
            {editText}
          </Link>
        </div>
      </AccessControl>
    </div>
  );
}

export default UnconnectedAlertEmailDisplay;
